export const ROLES = 'roles';
export const COUNTER = 'counter';
export const APP_NAME = 'Vehicle Feedback Database';
export const DASHBOARD_APP_NAME = 'Vehicle Feedback Database';
export const TOPIX_URL = 'https://topix.jaguar.jlrext.com/topix/vehicle/lookupForm';
export const MODAL_STATUS = `By selecting a specific Status field the VFDB will
                            return only DTCs where that status bit is set and exclude DTCs 
                            where that status bit is not set. Where other Status fields are 
                            NOT selected, all combinations (set and not set) will be included 
                            in the results. For example if "Confirmed DTC" field only is selected, 
                            all results will include DTCs with at least Confirmed status set and 
                            there will be no DTC records where it is not set. All the other Status 
                            combinations will be included.`;
export const BUG_REPORT_URL = `https://jira.devops.jlr-apps.com/browse/CDP`;
export const FEEDBACK_EMAIL = `vfdbvfasupport_GRP@jaguarlandrover.com`;
export const USER_GUIDE_URL = `https://jlrglobal.sharepoint.com/sites/diagnostic-design/D3M%20Data%20Share/Forms/AllItems.aspx?id=%2Fsites%2Fdiagnostic%2Ddesign%2FD3M%20Data%20Share%2FVFDB%20User%20Guide&viewid=b9fc9870%2D3be8%2D4a6b%2Dba7a%2D11a4cd3e08eb`;
export const TOOL_NAME = 'JLR NextGen Vehicle Feedback Database';
export const VERSION_NUMBER = '1.0';
export const RESPONSIBLE = 'JLR Diagnostics Team';
export const HELP_EMAIL = 'diag_grp@jaguarlandrover.com';
export const COPYRIGHT = 'Database - JLR Diagnostics 2020';

// export const environment = {
//   production: false,
//   clientID: '9ObvOsPwh0AuzsVV89UonFOR5LNzhWr3',
//   domain: 'jlr-auth.eu.auth0.com',
//   callbackURL: 'http://localhost:8080/callback',
//   audience: 'https://jlr-vehicle-fast-feedback-dev.api.com/',
//   baseUrl: 'http://localhost:8080',
//   namespace: 'https://jlr-vff-db.com/',
//   apiUrl: 'https://springboot-backend-dot-jlr-dl-vdm-da-live.appspot.com/v1',
// };

export const environment = {
  apiUrl: process.env.REACT_APP_API_URL,
  clientID: process.env.REACT_APP_CLIENT_ID || ``,
  domain: process.env.REACT_APP_DOMAIN || ``,
  callbackURL: process.env.REACT_APP_CALLBACK_URL,
  audience: process.env.REACT_APP_AUDIENCE,
  namespace: process.env.REACT_APP_NAMESPACE,
  baseUrl: process.env.REACT_APP_BASE_URL,
};
// TODO: Use this constants object to store all the short constants
export const constants = {
  // project prefix for project (change it to avoid COLLISIONS)
  STORAGE_PREFIX: 'avl',

  // page were to redirect
  MAIN_PAGE: '/dashboard',

  // default language of the application
  DEFAULT_LANGUAGE: 'en',

  // information for help
  BUG_REPORT_URL:
    'https://jira.devops.jlr-apps.com/rest/collectors/1.0/template/form/2bd4264e?os_authType=none#',
  FEEDBACK_URL:
    'https://jira.devops.jlr-apps.com/rest/collectors/1.0/template/form/3c6fa92c?os_authType=none#',
  TITLE: 'JLR Vehicle Feedback Database',
  TOOL_NAME: 'JLR NextGen Vehicle Feedback Database',
  TOOL_IMAGE: './assets/img/avl_logo_md.jpg',
  VERSION_NUMBER: '1.0',
  RESPONSIBLE: 'JLR Diagnostics Team',
  RESPONSIBLE_MAIL: 'rgbwebtools@avl.com',
  HELP_EMAIL: 'diag_grp@jaguarlandrover.com',
  COPYRIGHT: 'Database - JLR Diagnostics 2020',

  // locale id
  STANDARD_LOCALE_ID: 'en-GB',

  // remote avl data backend url
  AVL_DATA_BACKEND: 'https://test.rgb-hr.avl.com/avl-data-backend/public/v1',

  // default language column (-> needed for e.g. location)
  DEFAULT_LANGUAGE_COLUMN: 'nameEn',

  PERMISSION_TICKET_URL: 'http://www.google.de/',

  USER_GUIDE_URL: 'https://storage.cloud.google.com/vfdb-user-guide/VFDbUserGuide.pdf',

  DTC1000_DASHBOARD_URL:
    'https://datastudio.google.com/u/0/reporting/1r63drdQf5kA0yxIptUu8X5Z1O--dJqne/page/yy4QB',

  // to test frontend without backend
  withoutApi: true,
  fakeAdminUser: {
    id: 0,
    username: 'admin',
    password: 'admin',
    roles: ['admin'],
  },
  fakeUser: {
    id: 1,
    username: 'user',
    password: 'user',
    roles: ['user'],
  },
};
